import { Inject, Injectable } from '@angular/core';
import { AuthHeaders, CoreInjectorTokens, Environment, SignalrService } from '@fleet-beat/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapHubService {
  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private signalrService: SignalrService,
  ) {}

  connect(auth: AuthHeaders): Observable<signalR.HubConnection> {
    return this.signalrService.connect(`${this.environment.messagingHubUrl}/hubs/maps`, auth);
  }
}
